import ThemesProvider from './themes.provider';

export default ThemesProvider;
